import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { UtilitiesService } from 'src/app/services/utilities.service';

@Component({
    selector: 'app-print-notes',
    templateUrl: './print-notes.component.html',
    styleUrls: ['./print-notes.component.css'],
    standalone: false
})

export class PrintNotesComponent implements OnInit {
  notes: any = [];
  appointment: any;
  patient: any;

  date: any;

  constructor(private route: ActivatedRoute, private api: ApiService, private titleService: Title, public utility: UtilitiesService) {
    this.utility.show = false;
  }

  ngOnInit(): void {
    this.notes = JSON.parse(localStorage.getItem('notes') || 'null');
    this.appointment = JSON.parse(localStorage.getItem('app_details') || 'null');
    this.patient = JSON.parse(localStorage.getItem('patient') || 'null');

    this.setTitle(this.notes.details.patient_number);
  }

  ngAfterViewInit(): void {
    window.print();
  }

  public setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }
}
